// Wrapper around store, can be used on client and server

import { TDict } from '../../../shared/types/utilityTypes';
import { getFrontendRuntimeContext } from './frontendRuntimeContext';

type TSharedState<SiteMetaType, SiteConfigType> = {
  auth: any;
  isLoggedIn: boolean;
  currentFeatures: TDict<boolean>;
  consentManagementEnabled: boolean;
  siteMeta: SiteMetaType;
  siteConfig: SiteConfigType;
};

let currentStore: any = null;

export interface IFrontendStore {
  init(store: any): void;
  getState<SiteMetaType, SiteConfigType>(): TSharedState<SiteMetaType, SiteConfigType>;
  getStore(): any;
}

const frontendStore: IFrontendStore = {
  init(store: any) {
    const context = getFrontendRuntimeContext();
    if (context) {
      context.store = store;
      return;
    }
    currentStore = store;
  },

  getState() {
    const context = getFrontendRuntimeContext();
    const store = context ? context.store : currentStore;
    if (!store) {
      throw new Error('failed to find currentStore');
    }
    return store.getState();
  },

  /**
   * Returns the Redux store instance.
   * Use this for immediate reducer/saga injection at module load time.
   */
  getStore() {
    const context = getFrontendRuntimeContext();
    return context ? context.store : currentStore;
  }
};

export default frontendStore;
